// extracted by mini-css-extract-plugin
export default {"wrapper":"O5-z"};